import { createAction } from "redux-actions";
import { takeLatest, put, select, call, all } from "redux-saga/effects";
import axios from "axios";
import { queryParams } from "../../../../utils/queryParams";

const FETCH_CURRENT_USER = "sagas/reports/userLogins/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "sagas/reports/userLogins/FETCH_CURRENT_USER_SUCCESS";

export const UPDATE_TYPE = "sagas/reports/userLogins/UPDATE_TYPE";

export const FETCH_FILTERS_SUCCESS = "sagas/reports/userLogins/FETCH_FILTERS_SUCCESS";
export const UPDATE_FILTERS_SUCCESS = "sagas/reports/userLogins/UPDATE_FILTERS_SUCCESS";

export const FETCH_SCORECARDS = "sagas/reports/userLogins/FETCH_SCORECARDS";
export const FETCH_TABLE_DATA = "sagas/reports/userLogins/FETCH_TABLE_DATA";

export const UPDATE_DATA = "sagas/reports/userLogins/UPDATE_DATA";

const RESET_DATA = "sagas/reports/userLogins/RESET_DATA";
export const RESET_ALL_FILTERS = "sagas/reports/userLogins/RESET_ALL_FILTERS";

export const SET_UPDATES_LOADING = "sagas/reports/userLogins/SET_UPDATES_LOADING";

export const SET_LOADING = "sagas/reports/userLogins/SET_LOADING";
export const SET_FILTERS_DIRTY = "sagas/reports/userLogins/ET_FILTERS_DIRTY";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateFilters: createAction(UPDATE_FILTERS_SUCCESS),
  updateType: createAction(UPDATE_TYPE),
  updateData: createAction(UPDATE_DATA),
  resetData: createAction(RESET_DATA)
};

export default function* watchUserLogins() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(UPDATE_DATA, updateData);
  yield takeLatest(RESET_DATA, resetData);
}

function* fetchCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: data.payload
  });
  yield put({ type: SET_LOADING, payload: true });
  yield all([fetchFilters(), fetchScorecards(), fetchTables()]);

  yield put({ type: SET_LOADING, payload: false });
}

function* fetchFilters() {
  const sagaArguments = yield helperFunctions.getCommonApiParams();
  const [organization_id] = sagaArguments;
  if (organization_id) {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "reports/user_login_report/get_initial_filters",
      { organization_id }
    );

    yield put({
      type: FETCH_FILTERS_SUCCESS,
      payload: helperFunctions.formatFilters(response.data)
    });
  }
}

function* fetchScorecards() {
  const sagaArguments = yield helperFunctions.getCommonApiParams();
  const [organization_id, email, type] = sagaArguments;
  if (organization_id) {
    const params = {
      organization_id,
      email,
      type
    };
    const topScorecards = yield* helperFunctions.handleCallToApi("get_scorecards", params);
    const { user_activity: userActivity, scorecards: bottomScorecards } =
      yield* helperFunctions.handleCallToApi("get_user_activity", params);
    yield put({
      type: FETCH_SCORECARDS,
      payload: { topScorecards, bottomScorecards }
    });

    yield put({
      type: FETCH_TABLE_DATA,
      payload: { userActivity }
    });
  }
}
function* fetchTables() {
  const sagaArguments = yield helperFunctions.getCommonApiParams();
  const [organization_id, email] = sagaArguments;
  if (organization_id) {
    const params = { organization_id, email };
    const topNumberLogins = yield* helperFunctions.handleCallToApi("get_top_number_logins", params);
    const daysSinceLastLogin = yield* helperFunctions.handleCallToApi(
      "get_days_since_last_login",
      params
    );
    yield put({
      type: FETCH_TABLE_DATA,
      payload: { daysSinceLastLogin, topNumberLogins }
    });
  }
}

function* updateData() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  yield put({ type: SET_FILTERS_DIRTY, payload: false });

  yield all([fetchScorecards(), fetchTables()]);

  yield put({ type: SET_UPDATES_LOADING, payload: false });
}
function* resetData() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  yield put({ type: RESET_ALL_FILTERS });

  yield all([fetchFilters(), fetchScorecards(), fetchTables()]);

  yield put({ type: SET_UPDATES_LOADING, payload: false });
}

const helperFunctions = {
  getCommonApiParams: function* () {
    const { organization_id } = yield select((state) => state.commonReducer.commonProps);
    return yield select((state) => {
      const { selectedFilters, selectedTypeOption } = state.loginReport;
      let stringOfEmails = this.getEmailsFromArrayAndStringify(selectedFilters);
      return [organization_id.toString(), stringOfEmails, selectedTypeOption.toLowerCase()];
    });
  },
  handleCallToApi: function* (path, params) {
    const { data } = yield call(
      axios.post,
      queryParams.apiVersion + "reports/user_login_report/" + path,
      { ...params }
    );
    return data;
  },
  getEmailsFromArrayAndStringify: (array) => {
    const arrayOfNames = array.length > 0 ? array.map((val) => val.email) : [];
    return arrayOfNames.join();
  },
  formatFilters: ({ emails, names }) => {
    let formattedFilters = [];
    emails.forEach(([id, email], index) => {
      let triple = {
        id,
        email,
        name: names[index][1]
      };

      formattedFilters.push(triple);
    });
    return formattedFilters;
  }
};
